var _path, _circle, _path2, _circle2, _circle3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoDepartments(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 126,
    viewBox: "0 0 264 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7773 74.2013C64.0853 74.2013 71.3691 75.0887 77.5242 73.3301",
    stroke: "#FB7C51",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5997,
    cy: 42.8986,
    r: 10.9019,
    stroke: "#FB7C51",
    strokeWidth: 1.72
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 80.1922C2.47764 73.7891 3.90199 67.2932 9.43377 63.0106C13.1312 60.1481 17.7488 59.9925 22.2415 59.9657C28.5463 59.9281 35.0414 59.5611 41.3081 60.3523C47.5439 61.1397 53.9889 63.6278 56.2666 69.8977C57.8235 74.1836 58.1998 78.5167 58.1998 83.0196",
    stroke: "#FB7C51",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.1895,
    cy: 55.9634,
    r: 17.1303,
    stroke: "#FB7C51",
    strokeWidth: 1.72
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 219.255,
    cy: 17.9903,
    r: 17.1303,
    stroke: "#FB7C51",
    strokeWidth: 1.72
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4443 114.221C34.7044 104.427 36.8831 94.4916 45.3442 87.941C50.9995 83.5627 58.0624 83.3248 64.9341 83.2838C74.5777 83.2262 84.5122 82.665 94.0974 83.8752C103.635 85.0795 113.493 88.8852 116.977 98.4753C119.358 105.031 119.934 111.658 119.934 118.546",
    stroke: "#FB7C51",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M175.51 76.2481C177.77 66.4542 179.948 56.5184 188.41 49.9679C194.065 45.5896 201.128 45.3517 208 45.3107C217.643 45.2531 227.578 44.6918 237.163 45.9021C246.701 47.1063 256.559 50.912 260.042 60.5021C262.424 67.0576 262.999 73.6853 262.999 80.5726",
    stroke: "#FB7C51",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M165.822 56.1514C165.822 61.9174 161.289 66.5483 155.75 66.5483C150.211 66.5483 145.678 61.9174 145.678 56.1514C145.678 50.3855 150.211 45.7545 155.75 45.7545C161.289 45.7545 165.822 50.3855 165.822 56.1514Z",
    stroke: "#FB7C51",
    strokeWidth: 1.72
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.168 91.8423C130.542 85.7141 131.866 79.497 137.007 75.3982C140.444 72.6586 144.735 72.5098 148.911 72.4841C154.771 72.4481 160.808 72.0969 166.632 72.8541C172.428 73.6077 178.418 75.989 180.535 81.9897C181.982 86.0916 182.332 90.2387 182.332 94.5482",
    stroke: "#FB7C51",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81934 122.605C13.0689 121.013 16.7783 121.288 20.3165 121.262C30.6798 121.185 41.0508 121.25 51.4099 121.56C78.2965 122.366 105.186 123.092 132.054 124.396",
    stroke: "#FB7C51",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25156 88.5142C1.51541 92.563 1.81199 96.7205 1.7168 100.814",
    stroke: "#FB7C51",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.03 99.4664C152.395 99.4664 190.921 104.16 223.478 94.8584",
    stroke: "#FB7C51",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1494 86.3208C66.425 89.3688 70.6084 92.5387 74.7913 95.7119",
    stroke: "#FB7C51",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M205.215 48.3477C209.491 51.3956 213.674 54.5655 217.857 57.7388",
    stroke: "#FB7C51",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9611 86.3208C87.3608 87.04 85.6459 88.4799 83.9411 90.4946C82.8044 91.8381 81.3064 92.7106 80.0482 93.9059C79.0235 94.8795 77.9759 95.7776 76.958 96.7955",
    stroke: "#FB7C51",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M233.027 48.3477C230.426 49.0669 228.711 50.5068 227.007 52.5215C225.87 53.8649 224.372 54.7375 223.114 55.9328C222.089 56.9063 221.041 57.8044 220.023 58.8224",
    stroke: "#FB7C51",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.958 96.7959C78.4295 105.027 78.0143 113.111 78.764 121.357",
    stroke: "#FB7C51",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M220.023 58.8228C221.495 67.0541 221.08 75.1377 221.829 83.3841",
    stroke: "#FB7C51",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5209 103.989C83.4162 103.152 82.7877 104.26 82.987 104.712C83.1419 105.064 83.4811 105.238 83.6766 104.835C83.7503 104.683 83.3919 103.803 83.3207 103.589",
    stroke: "#FB7C51",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M226.586 66.0166C226.482 65.1792 225.853 66.2874 226.052 66.7396C226.207 67.0911 226.547 67.2652 226.742 66.862C226.816 66.7099 226.457 65.8298 226.386 65.6162",
    stroke: "#FB7C51",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3218 116.302C84.3129 115.944 84.0369 115.634 84.1272 116.04C84.1431 116.112 84.2632 116.119 84.3218 116.102C84.486 116.053 84.4219 115.593 84.4219 115.473C84.4219 115.228 84.4199 115.007 84.1661 115.301C84.0488 115.437 83.9214 116.047 83.9214 116.001",
    stroke: "#FB7C51",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDepartments);
export default __webpack_public_path__ + "static/media/NoDepartments.5c691e0fb47cfae8517864059de3e3e1.svg";
export { ForwardRef as ReactComponent };